export { default as LoyaltyPointsMeterWidget } from './loyalty-points-meter-widget';
